module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAYCAYAAACWTY9zAAAAAXNSR0IArs4c6QAAAHtJREFUSA1jZJzo/p+BBBCqasew0rOKBB0MDPeLqhne79xLkh4mklTTUfGow0gN7NEQGw0xUkOAVPWjaWw0xEgNAVLVj6ax0RAjNQRIVT+axkZDjNQQIFX9aBobNiHGEqBidZoU32gIyb4Cqr9Oih4OJXlNAWc7MVL0AABrkg0JXZrPtgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/Italy.png
// module id = 476
// module chunks = 7